import { render, staticRenderFns } from "./section-categories.vue?vue&type=template&id=d340b47a&"
import script from "./section-categories.vue?vue&type=script&lang=js&"
export * from "./section-categories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports